import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../../context-store";
import { Redirect, useHistory } from "react-router";
import { useForm, Controller } from "react-hook-form";
import toasterUtils from "../../../../utils/toaster-utils";
import InterviewRatingModel from "../../../../models/interviewer/response/InterviewRatingModel";
import dateUtils from "../../../../utils/date-utils";
import "../../../../landing-pages/Interviewer/rating.css";
import { FORM_SELECT_RULE } from "../../../../utils/validation-utils";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button as MuiButton, FormControl, InputLabel, Select, MenuItem, FormHelperText, TextField, Checkbox, FormControlLabel, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface RateInterviewProps {
    objRateInterview: InterviewRatingModel;
    onRatingUpdateAction: (objRateInterview: InterviewRatingModel) => void;
    onRatingClearAction: () => void;
}

const EditRatingUpdateComponent = (props: RateInterviewProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const history = useHistory();
    const [rating, setRating] = useState<number[]>([1, 2, 3, 4, 5]);
    const [expanded, setExpanded] = useState<false | "tech" | "soft">("tech");
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<InterviewRatingModel>({
        mode: "onChange",
        defaultValues: props.objRateInterview
    });

    const onSubmit = (formData: InterviewRatingModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        let ratingZero = formData.technicalSkillRating.find(x => x.rating === 0);
        let softSkillZero = formData.softSkillRating.find(x => x.rating === 0);
        if (ratingZero || softSkillZero) {
            toasterUtils.showError("Rating should not be 0.");
        } else {
            props.onRatingUpdateAction(formData);
        }
    };

    const clearRating = () => {
        props.onRatingClearAction();
    };

    const handleAccordionChange = (panel: "tech" | "soft") => (_: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-3">Candidate Name :</div>
                <div className="col-md-3"><span className="rating-value-lable">{props.objRateInterview.candidateName}</span></div>
                <div className="col-md-3">Interview Date & Time : </div>
                <div className="col-md-3"><span className="rating-value-lable">{dateUtils.getFormattedDateFromDate(props.objRateInterview.interviewDate)} - {props.objRateInterview.timeSlotName}</span></div>
            </div>
            <div className="row">
                <div className="col-md-3">Primary Skill :</div>
                <div className="col-md-3"><span className="rating-value-lable">{props.objRateInterview.primarySkillName}</span></div>
                <div className="col-md-3">Mobile No :</div>
                <div className="col-md-3"><span className="rating-value-lable">{props.objRateInterview.mobileNumber}</span></div>
            </div>
            <div className="row">
                <div className="col-md-3">Candidate Email :</div>
                <div className="col-md-3"><span className="rating-value-lable">{props.objRateInterview.mobileNumber}</span></div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <h3 className="rating-tip-header">Rating Tips/Interpretation</h3>
                    <p className="rating-tips">1. Know the subject but no good knowledge, need to learn.</p>
                    <p className="rating-tips">2. Know the subject, have knowledge but no good working exp.</p>
                    <p className="rating-tips">3. Have the knowledge and can work independently.</p>
                    <p className="rating-tips">4. Can work and Guide the team also to work.</p>
                    <p className="rating-tips">5. Exceptionally talented in this and is an asset to the team and to organization.</p>
                </div>
                <div className="col-md-6">
                    <h3 className="rating-tip-header">Key Responsibilities</h3>
                    <p></p>
                </div>
            </div>
            <div className="row">
                <Accordion expanded={expanded === "tech"} onChange={handleAccordionChange("tech")}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">TECHNICAL RATING</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {props.objRateInterview.technicalSkillRating.map((skill, index) => (
                            <div className="row">
                                <div className="col-md-3">
                                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                        {skill.secondarySkillName}
                                    </Typography>
                                </div>
                                <div className="col-md-3">
                                    <Controller name={`technicalSkillRating.${index}.rating`} control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                        render={({ field }) => (
                                            <FormControl fullWidth margin="normal" error={!!errors?.technicalSkillRating?.[index]?.rating}>
                                                <InputLabel required>Rating</InputLabel>
                                                <Select {...field} label="Rating" size="small">
                                                    <MenuItem value={0}>Select Rating</MenuItem>
                                                    {rating.map((type, idx) => (
                                                        <MenuItem key={idx} value={type}>
                                                            {type}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText>
                                                    {errors?.technicalSkillRating?.[index]?.rating?.message}
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <FormControl fullWidth margin="normal" error={!!errors?.technicalSkillRating?.[index]?.comments}>
                                        <TextField label="Address" multiline rows={2} size="small" placeholder="Min 50 and Max 200 characters"
                                            {...register(`technicalSkillRating.${index}.comments`, { required: skill.isCommentsRequired })} required={skill.isCommentsRequired}
                                            error={!!errors?.technicalSkillRating?.[index]?.comments} helperText={!!errors?.technicalSkillRating?.[index]?.comments} autoComplete="off" />
                                    </FormControl>
                                </div>
                            </div>
                        ))}
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === "soft"} onChange={handleAccordionChange("soft")}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">SOFT SKILL RATING</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {props.objRateInterview.softSkillRating.map((skill, index) => (
                            <div className="row">
                                <div className="col-md-3">
                                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                        {skill.softSkillName}
                                    </Typography>
                                </div>
                                <div className="col-md-3">
                                    <Controller name={`softSkillRating.${index}.rating`} control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                        render={({ field }) => (
                                            <FormControl fullWidth margin="normal" error={!!errors?.softSkillRating?.[index]?.rating}>
                                                <InputLabel required>Rating</InputLabel>
                                                <Select {...field} label="Rating" size="small">
                                                    <MenuItem value={0}>Select Rating</MenuItem>
                                                    {rating.map((type, idx) => (
                                                        <MenuItem key={idx} value={type}>
                                                            {type}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText>
                                                    {errors?.softSkillRating?.[index]?.rating?.message}
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <FormControl fullWidth margin="normal" error={!!errors?.softSkillRating?.[index]?.comments}>
                                        <TextField label="Address" multiline rows={2} size="small" placeholder="Min 50 and Max 200 characters"
                                            {...register(`softSkillRating.${index}.comments`, { required: true })} required
                                            error={!!errors?.softSkillRating?.[index]?.comments} helperText={!!errors?.softSkillRating?.[index]?.comments} autoComplete="off" />
                                    </FormControl>
                                </div>
                            </div>
                        ))}
                    </AccordionDetails>
                </Accordion>
            </div>
            <div className="row">
                <div className="col-md-12 padding-0">
                    <FormControl fullWidth margin="normal" error={!!errors?.interviewerComments}>
                        <TextField label="Comments" multiline rows={2} size="small" placeholder="Min 100 and Max 500 characters"
                            {...register("interviewerComments", { required: true })} required
                            error={!!errors?.interviewerComments} helperText={!!errors?.interviewerComments} autoComplete="off" />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Controller name="isGenuine" control={control} defaultValue={false}
                        render={({ field }) => (
                            <FormControl fullWidth margin="normal">
                                <FormControlLabel
                                    control={
                                        <Checkbox {...field} checked={field.value ?? false} onChange={(e) => field.onChange(e.target.checked)} color="primary" size="small" />
                                    }
                                    label="Is Genuine"
                                />
                            </FormControl>
                        )}
                    />
                </div>
                <div className="col-md-6">
                    <Controller name="recommendForNextRound" control={control} defaultValue={false}
                        render={({ field }) => (
                            <FormControl fullWidth margin="normal">
                                <FormControlLabel
                                    control={
                                        <Checkbox {...field} checked={field.value ?? false} onChange={(e) => field.onChange(e.target.checked)} color="primary" size="small" />
                                    }
                                    label="Recommend For Next Round"
                                />
                            </FormControl>
                        )}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-9"></div>
                <div className="col-md-3">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={clearRating}>
                        Cancel
                    </Button>
                </div>
            </div>
        </form >
    );
};
export default EditRatingUpdateComponent;